import { Breadcrumb, Spin, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useBeacon } from "../../api";
import { BeaconConfigModalSingle } from "../../components/configuration/BeaconConfigModalSingle";
import { BeaconDetails } from "../../components/details/BeaconDetails";
import { Battery } from "../../components/BeaconStatus";

export function Beacon() {
  const { t } = useTranslation();
  const history = useHistory();
  const { beaconId } = useParams<{ beaconId: string }>();
  const beacon = useBeacon(beaconId);

  if (!beacon.value) {
    return (
      <Spin className="centered" aria-label="loading-spinner" size="large" />
    );
  }

  return (
    <BeaconDetails
      beacon={beacon.value}
      breadcrumb={
        <Breadcrumb>
          <Breadcrumb.Item>
            <a
              href="/beacons"
              onClick={(e) => {
                e.preventDefault();
                history.push("/beacons");
              }}
            >
              {t("beacons")}
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span style={{ display: "flex", alignItems: "center" }}>
              <span style={{ marginRight: "1em" }}>
                {beacon.value
                  ? beacon.value.serial || beacon.value.beaconId
                  : beaconId}
              </span>
              <span>
                {beacon.value && (
                  <BeaconConfigModalSingle
                    selectedBeaconSerial={beacon.value.serial}
                  />
                )}
              </span>
              <Battery
                environment={beacon.value.sensors?.batt}
                absolute={false}
              />
              {!beacon.value.isEnabled ? (
                <span style={{ marginLeft: "2.5em" }}>
                  <Tag color="red">{t("beacon:disabled")}</Tag>
                </span>
              ) : (
                <span style={{ marginLeft: "2.5em" }}>
                  <Tag color="green">{t("beacon:enabled")}</Tag>
                </span>
              )}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
    />
  );
}
